import Ember from 'ember';

const { Handlebars } = Ember;

export default Handlebars.Utils.escapeExpression;
